import { RouterView } from 'vue-router'

export const tabsReportRoutes = [
  {
    path: 'reports',
    component: () => import('@/modules/reports/views/GenericReportsView.vue'),
    children: [
      {
        path: 'financial-records',
        component: RouterView,
        children: [
          {
            name: 'tabsOrganizationReport',
            path: 'tabs/:id?',
            component: () => import('@/modules/tabs-report/views/TabsReportFeatureFlag.vue'),
            props: { scope: 'organization' },
            meta: {
              locationTypes: ['organization']
            }
          },
          {
            name: 'tabsLocationReport',
            path: 'location-tabs/:id?',
            component: () => import('@/modules/tabs-report/views/TabsReportFeatureFlag.vue'),
            props: { scope: 'location' },
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          }
        ]
      }
    ]
  }
]
